class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=jd-predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-jd-predictive-search').innerHTML;
        console.log(searchTerm);

        var custfilter = new RegExp(searchTerm, "ig");
        var repstr = "<span class='highlight'>" + searchTerm + "</span>";

        var jdHighlightedMarkup = $.parseHTML(resultsMarkup);
        $(jdHighlightedMarkup).find("li span").each(function(){
          $(this).html($(this).html().replace(custfilter, repstr));
        });

        $(this.predictiveSearchResults).empty().append(jdHighlightedMarkup);
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    $(".ma-search-def-section").hide();
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    $(".ma-search-def-section").show();
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
